// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2":"dce517b986cf8edc","3":"fcbbd35dd991a569"}[chunkId] + ".js";
};